import Notifier from 'common/helpers/Notifier';
import {
  useClient,
  useCurrentEmployee,
  useProvider,
} from '../context/InteractionsContext';
import { useCreateRecord } from './APIHooks';
import { useInteractionConcepts } from './useInteractionConcepts';

export const useCreateInteraction = () => {
  const client = useClient();
  const currentEmployee = useCurrentEmployee();
  const provider = useProvider();
  const { typeConcept, interactionConcepts } = useInteractionConcepts();
  const { createRecord } = useCreateRecord('interaction', {
    mutationConfig: {
      onError: () => {
        Notifier.dispatch('error', 'Failed to create interaction...');
      },
    },
  });

  return async ({ start_time, end_time, note }) => {
    const employeeId = currentEmployee?.id;

    return createRecord({
      start_time,
      end_time,
      note: note || undefined,
      performing_org: provider?.id,
      performer: employeeId,
      recorded_by: employeeId,
      person: client?.id,
      state_concept: interactionConcepts?.stateConceptId,
      type_concept: typeConcept?.id,
      class_concept: interactionConcepts?.classConceptId,
    });
  };
};
